import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Iframe from "react-iframe";
import { YoutubeDataAPI } from "youtube-v3-api";
import VideoYoutube from "../components/VideoYoutube";

const ExtraC = styled.section`
  position: absolute;
  
  height: auto;
  display: flex;

  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100vh;
  @media (max-width: 450px) { width: 100%;  .container {
    display: flex;

    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 80%;
    .data-twitch {
      width: 100%;
      height: 500px;
      border: none;
      border-radius: 10px;
    }
    .channel-video {
      width: 100%;
      height: 186px;
      padding: 1em;
      overflow-x: scroll;
      overflow-y: hidden;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 2em;
    }
    h2 {
      font-family: Nunito;
      font-style: normal;
      font-weight: bold;
      font-size: 33px;
      line-height: 45px;

      color: #8e97f8;
      margin-bottom: 0px;
    }

    p {
      margin-top: 10px;
      font-family: Nunito;
      font-style: normal;
      font-weight: bold;
      font-size: 18px;
      line-height: 27px;

      color: #ffffff;
    }
    .platzi {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      gap: 1em;

      .curse {
        margin-top:2em;
        width: 260px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        padding: 0.5em;
        text-align: center;
        color: #fff;
        background-color: #4d4d4d;
        img {
          width: 50%;
        }
      }
    }

    h3 {
      color: #fff;
    }

    .ghost {
      width: 100%;
      height: 59px;
    }
    a {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    h1 {
      width: 80%;

      font-family: Nunito;
      font-style: normal;
      font-weight: normal;
      font-size: 27.8px;
      line-height: 23px;
      color: #fff;
    }
  }}
  @media (min-width: 450.1px) and (max-width:1000px){
    width:85%;
    .container {
    display: flex;

    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 85%;
    .data-twitch {
      width: 100%;
      height: 500px;
      border: none;
      border-radius: 10px;
    }
    .channel-video {
      width: 100%;
      height: autoprefixer;
      padding: 1em;
      
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      align-items: center;
      gap: 2em;
    }
    h2 {
      font-family: Nunito;
      font-style: normal;
      font-weight: bold;
      font-size: 33px;
      line-height: 45px;

      color: #8e97f8;
      margin-bottom: 0px;
    }

    p {
      margin-top: 10px;
      font-family: Nunito;
      font-style: normal;
      font-weight: bold;
      font-size: 35px;
      line-height: 50px;

      color: #ffffff;
    }
    .platzi {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      gap: 1em;

      .curse {
        width: 460px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        padding: 0.5em;
        text-align: center;
        color: #fff;
        background-color: #4d4d4d;
        img {
          width: 50%;
        }
      }
    }

    h3 {
      color: #fff;
    }

    .ghost {
      width: 100%;
      height: 59px;
    }
    a {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    h1 {
      width: 80%;

      font-family: Nunito;
      font-style: normal;
      font-weight: normal;
      font-size: 60.8px;
      line-height: 23px;
      color: #fff;
    }
  }
 
  
  }
  @media (min-width: 1000.1px){
    .container {
    display: flex;

    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 85%;
    .data-twitch {
      width: 100%;
      height: 500px;
      border: none;
      border-radius: 10px;
    }
    .channel-video {
      width: 100%;
      height: autoprefixer;
      padding: 1em;
      
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      align-items: center;
      gap: 2em;
    }
    h2 {
      font-family: Nunito;
      font-style: normal;
      font-weight: bold;
      font-size: 33px;
      line-height: 45px;

      color: #8e97f8;
      margin-bottom: 0px;
    }

    p {
      margin-top: 10px;
      font-family: Nunito;
      font-style: normal;
      font-weight: bold;
      font-size: 40px;
      line-height: 50px;

      color: #ffffff;
    }
    .platzi {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      gap: 1em;

      .curse {
        width: 460px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        padding: 0.5em;
        text-align: center;
        color: #fff;
        background-color: #4d4d4d;
        img {
          width: 50%;
        }
      }
    }

    h3 {
      color: #fff;
    }

    .ghost {
      width: 100%;
      height: 59px;
    }
    a {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    h1 {
      width: 80%;

      font-family: Nunito;
      font-style: normal;
      font-weight: normal;
      font-size: 60.8px;
      line-height: 23px;
      color: #fff;
    }
   
  }
  width:100%;
  }
  

`;
function Extra() {
  const [data, setData] = useState(null);
  const dataPlatzi = [
    {
      id: 1814,
      title: "Curso Básico de JavaScript",
      badge:
        "https://static.platzi.com/media/achievements/badge-basicojs-e2ead888-428e-4f55-962c-8894aeaeacda.png",
      url: "/clases/basico-javascript/",
      career: "Arquitectura Frontend",
      diploma_link:
        "/p/FranciscoJimenez/curso/1814-basico-javascript/diploma/detalle/",
    },
    {
      id: 1741,
      title: "Curso de Computación Básica",
      badge:
        "https://static.platzi.com/media/achievements/badge-computacion-basica-7bbb6f8a-04e3-4af2-82f2-8b8f2932ba04.png",
      url: "/clases/computacion-basica/",
      career: null,
      diploma_link:
        "/p/FranciscoJimenez/curso/1741-computacion-basica/diploma/detalle/",
    },
    {
      id: 1640,
      title: "Curso de Frontend Developer",
      badge:
        "https://static.platzi.com/media/achievements/badge-frontend-developer-8a49e681-3e22-408d-b886-2f47dfc9953a.png",
      url: "/clases/frontend-developer/",
      career: "JavaScript",
      diploma_link:
        "/p/FranciscoJimenez/curso/1640-frontend-developer/diploma/detalle/",
    },
    {
      id: 2042,
      title:
        "Curso de Prework: Configuración de Entorno de Desarrollo en Windows",
      badge:
        "https://static.platzi.com/media/achievements/badge-prework-configuracion-entorno-windows-8b168efb-2001-4f5e-938f-a333861ab31d.png",
      url: "/clases/prework-windows/",
      career: null,
      diploma_link:
        "/p/FranciscoJimenez/curso/2042-prework-windows/diploma/detalle/",
    },
    {
      id: 1050,
      title: "Curso Gratis de Programación Básica",
      badge:
        "https://static.platzi.com/media/achievements/1050-bfb74f83-8e2e-4ff7-a66d-77d2c0067908.png",
      url: "/clases/programacion-basica/",
      career: "Backend Profesional",
      diploma_link:
        "/p/FranciscoJimenez/curso/1050-programacion-basica/diploma/detalle/",
    },
    {
      id: 1651,
      title: "Curso Práctico de React JS",
      badge:
        "https://static.platzi.com/media/achievements/badge-react-adec89d0-1c35-4c9c-847e-18c284dc79dd.png",
      url: "/clases/react-ejs/",
      career: "JavaScript",
      diploma_link: "/p/FranciscoJimenez/curso/1651-react-ejs/diploma/detalle/",
    },
    {
      id: 1339,
      title: "Fundamentos de JavaScript",
      badge:
        "https://static.platzi.com/media/achievements/badge-fundamentos-javascript-61c15bdf-0a83-4aed-8537-b4753e4071e1.png",
      url: "/clases/fundamentos-javascript/",
      career: "JavaScript",
      diploma_link:
        "/p/FranciscoJimenez/curso/1339-fundamentos-javascript/diploma/detalle/",
    },
  ];
  const API_KEY = "AIzaSyAX032hcrM24yJnoZeKSc0xlToWR_MMU8Y";
  const api = new YoutubeDataAPI(API_KEY);
  useEffect(() => {
    api
      .searchPlaylistItems("PLgng5bcXfs100P351rmVz47UllChnUICJ", 5)

      .then((res) => setData(res))
      .catch((err) => console.log(err));
  }, []);

  return (
    <ExtraC>
      <div className="container">
        <h1>Extra</h1>
        <p>
          Hello I am 18 years old I like to program in my free time I like to
          learn about new technologies and share what I learn through video on
          the youtube platform and doing streams on the twitch platform.
        </p>

        <h3>Twitch </h3>
        <Iframe
          className="data-twitch"
          id="data-twitch"
          url="https://player.twitch.tv/?channel=pamsho_js&parent=pamshojs.netlify.app&autoplay=false"
        />
        <h3>Youtube </h3>

        <div className="channel-video">
          {data &&
            data.items.map((e) => {
              console.log(e);
              return <VideoYoutube {...e} />;
            })}
        </div>
        <p>
          I like to learn through courses in udemy and platzi I have the
          following courses approved.
        </p>

        <div className="platzi">
          {dataPlatzi.map((e) => (
            <div className="curse">
              <a
                className="curse"
                rel="noreferrer"
                href={`http://www.platzi.com${e.diploma_link}`}
                target="_blank"
              >
                <img src={e.badge} />
                <h4>{e.title}</h4>
              </a>
            </div>
          ))}
        </div>
        <div className="ghost "></div>
      </div>
    </ExtraC>
  );
}

export default Extra;
